export const LOCAL_STORAGE_SAVED_ITEMS_KEY = "wif_local_storage_saved_items";
export const LOCAL_STORAGE_AINO_PREVENT_POPUP_KEY =
  "wif_aino_prevent_chatPanel_Popup";
export const LOCAL_STORAGE_JOBS_SEARCH_HISTORY = "wif-jobs-search-history";
